__turbopack_context__.v({
  "content": "f-a-q1440px-module-scss-module__YxvPkW__content",
  "faq": "f-a-q1440px-module-scss-module__YxvPkW__faq",
  "faq1440px": "f-a-q1440px-module-scss-module__YxvPkW__faq1440px",
  "howCanIBook": "f-a-q1440px-module-scss-module__YxvPkW__howCanIBook",
  "icon": "f-a-q1440px-module-scss-module__YxvPkW__icon",
  "icontext": "f-a-q1440px-module-scss-module__YxvPkW__icontext",
  "item6": "f-a-q1440px-module-scss-module__YxvPkW__item6",
  "items": "f-a-q1440px-module-scss-module__YxvPkW__items",
  "text": "f-a-q1440px-module-scss-module__YxvPkW__text",
  "title": "f-a-q1440px-module-scss-module__YxvPkW__title",
  "title1": "f-a-q1440px-module-scss-module__YxvPkW__title1",
});
